const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/widget/components/widget-axis");